<template>
    <!-- <b-modal ref="mdlSchedaEsameObiettivoGenerale" title="Scheda Esame Obiettivo Generale " @hidden="onCloseModal" @ok="onSalvaSchedaEsameObiettivoGenerale" centered no-close-on-backdrop no-close-on-esc hide-header-close size="xl" scrollable @show="onShow"> -->
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <rsa-scheda-esame-obiettivo-generale-generali-edit-component :jsonData="jsonData.esameObiettivoGeneraleGenerali" @update="onUpdateEsameObiettivoGeneraleGenerali" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpGenerali" />
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <rsa-scheda-esame-obiettivo-generale-sistema-nervoso-edit-component :key="key" :jsonDataSistemaNervoso="jsonData.esameObiettivoGeneraleSistemaNervoso" @update="onUpdateEsameObiettivoGeneraleSistemaNervoso" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpSistemaNervoso" />
            <rsa-scheda-esame-obiettivo-generale-cute-edit-component :jsonDataCute="jsonData.esameObiettivoGeneraleCute" @update="onUpdateEsameObiettivoGeneraleCute" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpCute" />
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <rsa-scheda-esame-obiettivo-generale-torace-edit-component :jsonDataTorace="jsonData.esameObiettivoGeneraleTorace" @update="onUpdateEsameObiettivoGeneraleTorace" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpTorace" />
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <rsa-scheda-esame-obiettivo-generale-addome-edit-component :jsonDataAddome="jsonData.esameObiettivoGeneraleAddome" @update="onUpdateEsameObiettivoGeneraleAddome" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpAddome" />
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <rsa-scheda-esame-obiettivo-generale-polso-radiale-edit-component :jsonDataPolsoRadiale="jsonData.esameObiettivoGeneralePolsoRadiale" @update="onUpdateEsameObiettivoGeneralePolsoRadiale" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpPolsoRadiale" />
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <rsa-scheda-esame-obiettivo-generale-esame-cardiologico-edit-component :jsonDataEsameCardiologico="jsonData.esameObiettivoGeneraleEsameCardiologico" @update="onUpdateEsameObiettivoGeneraleEsameCardiologico" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpEsameCardiologico" />
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-card class="sa-card sa-card-border" header="Note Scheda" header-tag="header" footer-tag="footer" title="">
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <span v-if="isReadOnly">{{ jsonData.note }}</span>
                    <b-form-textarea v-else v-model="jsonData.note" :readonly="isReadOnly" max-rows="10" rows="7"> </b-form-textarea>
                </b-col>
            </b-card>
        </b-col>
    </b-row>
    <!-- <template #modal-footer>
            <b-button v-if="!isReadOnly" variant="outline-danger" @click="$refs.mdlSchedaEsameObiettivoGenerale.hide()">Annulla</b-button>
            <b-button v-if="!isReadOnly" variant="outline-success" @click="onSalvaSchedaEsameObiettivoGenerale()">Salva</b-button>
            <b-button v-if="isReadOnly" variant="outline-primary" @click="$refs.mdlSchedaEsameObiettivoGenerale.hide()"> Chiudi </b-button>
        </template>
    </b-modal> -->
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaSchedaEsameObiettivoGeneraleGeneraliEditComponent from "./RsaSchedaEsameObiettivoGeneraleGeneraliEditComponent.vue";
import RsaSchedaEsameObiettivoGeneraleSistemaNervosoEditComponent from "./RsaSchedaEsameObiettivoGeneraleSistemaNervosoEditComponent.vue";
import RsaSchedaEsameObiettivoGeneraleCuteEditComponent from "./RsaSchedaEsameObiettivoGeneraleCuteEditComponent.vue";
import RsaSchedaEsameObiettivoGeneraleToraceEditComponent from "./RsaSchedaEsameObiettivoGeneraleToraceEditComponent.vue";
import RsaSchedaEsameObiettivoGeneraleAddomeEditComponent from "./RsaSchedaEsameObiettivoGeneraleAddomeEditComponent.vue";
import RsaSchedaEsameObiettivoGeneraleEsameCardiologicoEditComponent from "./RsaSchedaEsameObiettivoGeneraleEsameCardiologicoEditComponent.vue";

import RsaSchedaEsameObiettivoGeneralePolsoRadialeEditComponent from "./RsaSchedaEsameObiettivoGeneralePolsoRadialeEditComponent.vue";

export default {
    mixins: [UtilityMixin],
    components: {
        RsaSchedaEsameObiettivoGeneraleGeneraliEditComponent,
        RsaSchedaEsameObiettivoGeneraleSistemaNervosoEditComponent,
        RsaSchedaEsameObiettivoGeneraleCuteEditComponent,
        RsaSchedaEsameObiettivoGeneraleToraceEditComponent,
        RsaSchedaEsameObiettivoGeneraleAddomeEditComponent,
        RsaSchedaEsameObiettivoGeneralePolsoRadialeEditComponent,
        RsaSchedaEsameObiettivoGeneraleEsameCardiologicoEditComponent,
    },
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
    },
    data() {
        return {
            pathResourceDizionario: "/rsadizionario",
            key: 0,
            pathResourceSchedaEsameObiettivoGenerale: "/rsaschedaesameobiettivogenerale",
            pathResourceCheckSchedaEsameObiettivoGenerale: "/rsaschedaesameobiettivogenerale/check",
            // idAccettazione: null,
            jsonData: {
                id: null,
                idAccettazione: null,
                note: null,
                esameObiettivoGeneraleAddome: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    forma: null,
                    formaDescrizione: "",
                    cicatriceOmbelicale: null,
                    cicatriceOmbelicaleDescrizione: "",
                    cicatriceChirurgica: null,
                    cicatriceChirurgicaDescrizione: "",
                    reticoloVenoso: null,
                    reticoloVenosoDescrizione: "",
                    trattabilita: null,
                    trattabilitaDescrizione: "",
                    reazioneDifesaDescrizione: "",
                    massaAddominale:null,
                    massaAddominaleDescrizione: "",
                    percussione: null,
                    percussioneDescrizione: "",
                    elementoSemeiologicoRilievo: "",
                    noteAddome: "",
                    listaSchedaAddomeDettagli: [],
                },
                esameObiettivoGeneraleCute: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    colorito:null,
                    integrita: null,
                    integritaDescrizione: "",
                    edemi: null,
                    noteCute: "",
                    listaSchedaCuteDettagli: [],
                },
                esameObiettivoGeneraleEsameCardiologico: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    azioneCardiaca: null,
                    toniCardiaci: null,
                    toniCardiaciDescrizione: "",
                    itto: null,
                    ittoDescrizione: "",
                    pause: null,
                    pauseDescrizione: "",
                    noteEsameCardiologico: "",
                },
                esameObiettivoGeneraleGenerali: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    condizioneClinicaGenerale: null,
                    sensorio: null,
                    postura: null,
                    protesi: null,
                    protesiDescrizione: "",
                    peso: 0,
                    altezza: 0,
                    alvo: "",
                    diuresi: "",
                    alimentazione: "",
                    statoNutrizionale: null,
                    decubito: null,
                    visus: null,
                    bocca: null,
                    note: "",
                    esameNeurologico: "",
                    ossaArticolazioni: "",
                },
                esameObiettivoGeneralePolsoRadiale: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    ritmo: null,
                    polsoPeriferico: null,
                    frequenzaBpm: 0,
                    respiro: null,
                    respiroDescrizione: "",
                    notePolsoRadiale: "",
                },
                esameObiettivoGeneraleSistemaNervoso: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    statoCoscienzaNelTempo: null,
                    statoCoscienzaNelloSpazio: null,
                    attenzione: null,
                    linguaggio: null,
                    memoriaBreveTermine: null,
                    memoriaLungoTermine: null,
                    noteSistemaNervoso: "",
                },
                esameObiettivoGeneraleTorace: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    conformazione: "",
                    espansibilita: null,
                    fremitoVocaleTattile: null,
                    suonoPlessico: null,
                    suonoPlessicoDescrizione: "",
                    murmuraVescicolare: null,
                    rumoreBronchiale: null,
                    rumoreBronchialeDescrizione: "",
                    rumorePolmonare: null,
                    rumorePolmonareDescrizione: "",
                    rumorePleurico: null,
                    rumorePleuricoDescrizione: "",
                    noteTorace: "",
                },
            },
        };
    },
    mounted() {
        let me = this;
        me.jsonData.idAccettazione = me.idAccettazione;
        if (me.idRisorsa !== null) {
            me.loadData();
        }
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    methods: {
        loadData() {
            let me = this;
            let path = process.env.VUE_APP_PATH_API + me.pathResourceSchedaEsameObiettivoGenerale + "/" + me.idRisorsa;
            UtilityMixin.methods.restCallGet(path, null, me.loadDataSuccess, me.loadDataError);
        },

        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
        },
        loadDataError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onSalvaSchedaEsameObiettivoGenerale() {
            let me = this;
            me.jsonData.idAccettazione = me.idAccettazione;
            /* console.log("Salvataggio Generali con dati:", JSON.stringify(me.jsonData)); */
            if (!me.jsonData.idAccettazione) {
                // console.log("idAccettazione: ", me.jsonData.idAccettazione);
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaEsameObiettivoGenerale, me.jsonData, me.saveSchedaEsameObiettivoGeneraleSuccessResponse, me.saveSchedaEsameObiettivoGeneraleErrorResponse);
            me.$refs.cmpGenerali.onSalvaSchedaEsameObiettivoGeneraleGenerali();
            me.$refs.cmpSistemaNervoso.onSalvaSistemaNervoso();
            me.$refs.cmpCute.onSalvaCute();
            me.$refs.cmpTorace.onSalvaTorace();
            me.$refs.cmpAddome.onSalvaAddome();
            me.$refs.cmpPolsoRadiale.onSalvaPolsoRadiale();
            me.$refs.cmpEsameCardiologico.onSalvaEsameCardiologico();
        },

        saveSchedaEsameObiettivoGeneraleSuccessResponse() {
            let me = this;
            //console.log("Esame generale salvato con successo:", response);
            me.$emit("afterSaveSuccess");

            me.$refs.mdlSchedaEsameObiettivoGenerale.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        saveSchedaEsameObiettivoGeneraleErrorResponse(response) {
            let me = this;
            if (response.response.status === 400) {
                me.$bvModal.msgBoxOk(response.response.data.messaggio, {
                    title: "ATTEZIONE",
                    size: "md",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
            } else {
                me.$bvToast.toast("Errore nel salvataggio in edit component" + response.message, {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        onUpdateEsameObiettivoGeneraleAddome(data) {
            let me = this;
            me.jsonData.esameObiettivoGeneraleAddome = data;
        },
        onUpdateEsameObiettivoGeneraleCute(data) {
            let me = this;
            me.jsonData.esameObiettivoGeneraleCute = data;
        },
        onUpdateEsameObiettivoGeneraleEsameCardiologico(data) {
            let me = this;
            me.jsonData.esameObiettivoGeneraleEsameCardiologico = data;
        },
        onUpdateEsameObiettivoGeneraleGenerali(data) {
            let me = this;
            me.jsonData.esameObiettivoGeneraleGenerali = data;
        },
        onUpdateEsameObiettivoGeneralePolsoRadiale(data) {
            let me = this;
            me.jsonData.esameObiettivoGeneralePolsoRadiale = data;
        },
        onUpdateEsameObiettivoGeneraleSistemaNervoso(data) {
            let me = this;
            me.jsonData.esameObiettivoGeneraleSistemaNervoso = data;
        },
        onUpdateEsameObiettivoGeneraleTorace(data) {
            let me = this;
            me.jsonData.esameObiettivoGeneraleTorace = data;
        },
        /*  resetForm() {
            let me = this;
            me.jsonData = {
                id: null,
                idAccettazione: me.idAccettazione,
                note: null,
            };
        },
 */
        /*  show(value, isReadOnly) {
            let me = this;
            me.isReadOnly = isReadOnly;
            me.$refs.mdlSchedaEsameObiettivoGenerale.show();
            value;
        }, */

        /*  onCloseModal() {
            let me = this;
            me.resetForm();
            me.$emit("onCloseModal");
        },
        onShow() {
            // console.log("SHOW");
            let me = this;
            me.loadData();
        }, */
    },
};
</script>
